import React from 'react';
//import 'bootstrap/dist/css/bootstrap-reboot.min.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';

import './App.css';
import './design-system.css';
//import "@material/react-switch/dist/switch.css";

import AppStore from './store/App';
import ManpowerWeb from './screens/App';
import 'mapbox-gl/dist/mapbox-gl.css';

const App = () => <AppStore></AppStore>;

export default App;
